import { render, staticRenderFns } from "./_0.vue?vue&type=template&id=5520f196&"
import script from "./_0.vue?vue&type=script&lang=js&"
export * from "./_0.vue?vue&type=script&lang=js&"
import style0 from "./_0.vue?vue&type=style&index=0&id=5520f196&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports